var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":_vm.$style.main}},[_c('main-title',{class:_vm.$style.main_title,attrs:{"main_title":'お客様のお声',"sub_title":'〜 Customer Voice〜',"color":'#192C58',"align":'center'}}),_c('customer-voice-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }